
<section class="fatura-pagamento" [class.fatura-pagamento--modal]="emModal">
  <div class="fatura-pagamento__secao-titulo">
    <i class="far fa-file-alt"></i>
    <h5>Resumo da fatura</h5>
  </div>

  <div class="fatura-pagamento__resumo">
    <div class="fatura-pagamento__resumo-item">
      <span>Referência</span>
      <strong>{{fatura.referencia || '-'}}</strong>
    </div>

    <div class="fatura-pagamento__resumo-item">
      <span>Vencimento</span>
      <strong>{{fatura.dataVencimentoFormatada || fatura.dataVencimento || '-'}}</strong>
    </div>

    <div class="fatura-pagamento__resumo-item fatura-pagamento__resumo-item--valor"
         [class.fatura-pagamento__resumo-item--valor-atrasado]="fatura.vencida">
      <span>Valor da parcela</span>
      <strong>{{numeroParcelas}}x {{valorParcela | currency:'BRL'}}</strong>
    </div>

    <div class="fatura-pagamento__resumo-item">
      <span>Status</span>
      <strong class="fatura-pagamento__status"
              [ngClass]="{'fatura-pagamento__status--atrasada': fatura.vencida}">
        {{fatura.status || (fatura.vencida ? 'Vencida' : 'Disponível')}}
      </strong>
    </div>
  </div>

  <ng-container *ngIf="fatura.pix || fatura.boleto || fatura.cartao">
    <div class="fatura-pagamento__secao-titulo fatura-pagamento__secao-titulo--pagamento">
      <i class="far fa-credit-card"></i>
      <h5>Escolha uma forma de pagamento</h5>
    </div>

    <div class="fatura-pagamento__formas"
         [class.fatura-pagamento__formas--complementares]="fatura.pix && (fatura.boleto || fatura.cartao)">
      <article class="fatura-pagamento__cartao fatura-pagamento__cartao--pix" *ngIf="fatura.pix">
        <div class="fatura-pagamento__pix-conteudo">
          <div class="fatura-pagamento__pix-dados">
            <div class="fatura-pagamento__forma-cabecalho">
              <span class="fatura-pagamento__forma-icone fatura-pagamento__forma-icone--pix">
                <i class="fas fa-qrcode"></i>
              </span>
              <div>
                <h6>Pix</h6>
                <p>Escaneie o QR Code ou copie o código Pix.</p>
              </div>
            </div>

            <div class="fatura-pagamento__valor-pix">
              <span>Valor a pagar</span>
              <strong>{{fatura.total | currency:'BRL'}}</strong>
            </div>

            <div class="fatura-pagamento__pix-codigo" *ngIf="fatura.pix.qrcodeText"
                 [class.fatura-pagamento__pix-codigo--copiado]="mensagemCopiada === fatura.pix.qrcodeText">
              <span>{{fatura.pix.qrcodeText}}</span>
              <button type="button" (click)="copyMessage(fatura.pix.qrcodeText)"
                      [attr.aria-label]="mensagemCopiada === fatura.pix.qrcodeText ? 'Código Pix copiado' : 'Copiar código Pix'">
                <i class="far"
                   [ngClass]="mensagemCopiada === fatura.pix.qrcodeText ? 'fa-check-circle' : 'fa-copy'"></i>
              </button>
            </div>
          </div>

          <div class="fatura-pagamento__qr" *ngIf="temImagemPix()">
            <img [src]="obtenhaImagemQrCodePix()" alt="QR Code para pagamento da fatura via Pix">
          </div>
        </div>

        <button type="button" class="fatura-pagamento__acao fatura-pagamento__acao--pix"
                [class.fatura-pagamento__acao--copiada]="mensagemCopiada === fatura.pix.qrcodeText"
                *ngIf="fatura.pix.qrcodeText" (click)="copyMessage(fatura.pix.qrcodeText)">
          <i class="far" [ngClass]="mensagemCopiada === fatura.pix.qrcodeText ? 'fa-check-circle' : 'fa-copy'"></i>
          {{mensagemCopiada === fatura.pix.qrcodeText ? 'Código Pix copiado' : 'Copiar código Pix'}}
        </button>
      </article>

      <article class="fatura-pagamento__cartao fatura-pagamento__cartao--outras"
               *ngIf="fatura.boleto || fatura.cartao">
        <div class="fatura-pagamento__forma-cabecalho">
          <span class="fatura-pagamento__forma-icone">
            <i class="far fa-credit-card"></i>
          </span>
          <div>
            <h6>Outras formas de pagamento</h6>
            <p>Pague com boleto bancário ou cartão de crédito.</p>
          </div>
        </div>

        <div class="fatura-pagamento__outras-acoes">
          <a class="fatura-pagamento__acao" [href]="fatura.boleto.link" target="_blank" rel="noopener"
             *ngIf="fatura.boleto && fatura.boleto.link">
            <i class="fas fa-barcode"></i>
            <span>Baixar boleto</span>
            <i class="fas fa-chevron-right"></i>
          </a>

          <button type="button" class="fatura-pagamento__acao" (click)="abraModalPagarCartao()"
                  *ngIf="fatura.cartao">
            <i class="far fa-credit-card"></i>
            <span>Pagar com cartão</span>
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </article>
    </div>
  </ng-container>

  <div class="fatura-pagamento__lembrete">
    <i class="fas fa-info-circle"></i>
    <span *ngIf="!fatura.vencida">Pagando até o vencimento, você evita multa, juros e interrupção de acesso.</span>
    <span *ngIf="fatura.vencida">Assim que o pagamento for identificado, o acesso ao sistema será liberado automaticamente.</span>
  </div>
</section>
